import type { ReactNode } from 'react';
import { cx } from '../internal/tone';
import { IconButton } from '../actions/IconButton';
import { Spinner } from '../display/Spinner';

export interface ScreenProps {
  title: string;
  /** Se existir, desenha o botão "Voltar" à esquerda do título. */
  back?: () => void;
  actions?: ReactNode;
  loading?: boolean;
  children?: ReactNode;
  className?: string;
}

/**
 * Moldura de qualquer tela: cabeçalho fixo com voltar/título/ações e o corpo.
 *
 * O título é o único <h1> da página — é por ele que o leitor de tela anuncia
 * onde ela está depois de navegar.
 */
export function Screen({
  title,
  back,
  actions,
  loading = false,
  children,
  className,
}: ScreenProps) {
  return (
    <div className={cx('flos-screen', className)}>
      <header className="flos-screen__header">
        {back ? <IconButton icon="←" label="Voltar" onClick={back} /> : null}
        <h1 className="flos-screen__title">{title}</h1>
        {actions ? <div className="flos-screen__actions">{actions}</div> : null}
      </header>
      <main className="flos-screen__body">
        {loading ? (
          <div className="flos-screen__loading">
            <Spinner />
          </div>
        ) : (
          children
        )}
      </main>
    </div>
  );
}
